// Add your custom JS here.
function toggleMainMenu() {
	let btnMenu = $('#btn-main-menu');
	let containerMenu = $('#container-main-menu');
	btnMenu.toggleClass('open');
	containerMenu.toggleClass('open');
	setTimeout(() => {
		$('body').toggleClass('overflow-hidden');
	}, 800);
}
$('#btn-main-menu, #menu-menu a').on('click', toggleMainMenu);

document.addEventListener('DOMContentLoaded', function () {
	var mySwiper = new Swiper('.vertical-gallery', {
		direction: 'vertical',
		loop: true,
		slidesPerView: 1,
		allowTouchMove: true,
		autoHeight: false, // Desactiva autoHeight
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});
});

jQuery(document).ready(function ($) {
	// Obtenemos la URL de la categoría actual
	var currentCategoryUrl = window.location.href;

	// Buscamos los enlaces de categorías en el widget y agregamos la clase 'current-cat' si la URL coincide
	$('.wc-block-product-categories-list a').each(function () {
		var categoryUrl = $(this).attr('href');

		if (currentCategoryUrl.indexOf(categoryUrl) !== -1) {
			$(this).addClass('current-cat');
		}
	});
});
